import { IComplexId } from '@/shared/Models/Index';
import { ArgumentValidator } from './argument-validator';

export class ComplexIdHelper  {

    public static create(identifer: string): IComplexId {

        ArgumentValidator.notNullOrEmpty(identifer, 'identifer');

        const split = identifer.split('/');

        if (split.length !== 2) {

            return null as unknown as IComplexId;
        }

        return {
            prefix: split[0],
            id: split[1]
        };
    }

    public static createForCandidature(identifer: string): IComplexId {

        ArgumentValidator.notNullOrEmpty(identifer, 'identifer');

        const split = identifer.split('/');

        if (split.length !== 3) {

            return null as unknown as IComplexId;
        }

        return {
            prefix: `${split[0]}/${split[1]}`,
            id: split[2]
        };
    }

    public static createId(id: IComplexId): string {

        ArgumentValidator.notNullOrEmpty(id, 'id');

        return `${id.prefix}/${id.id}`;
    }
}
